import { RatesWidget } from '@/app_components/common/widgets/RatesWidget/RatesWidget';
import { defaultRatesFormValues } from '@/app_data/widgets/RedVentures/constants';
import { getCdRates } from '@/app_data/widgets/RedVentures/getCdRatesRv';
import { getSavingsMma } from '@/app_data/widgets/RedVentures/getSavingsMmaRv';

interface WidgetProps {
  className?: string;
  // TODO: Add this back
  // postId: number;
}

export const CdRatesWidget = async (props: WidgetProps) => {
  const data = await getCdRates(defaultRatesFormValues);

  return (
    <RatesWidget
      {...props}
      initialData={data}
      type='CD'
    />
  );
};

export const SavingsWidget = async (props: WidgetProps) => {
  const data = await getSavingsMma(defaultRatesFormValues);

  return (
    <RatesWidget
      {...props}
      initialData={data}
      type='Savings'
    />
  );
};
